module.exports = __webpack_public_path__ + "img/yusuanlv.dde45d1e.png";